var i4_Gallery = {
	instances: {},

	get: function(gallery_id) {
		var result = null;

		if (this.instances[gallery_id]) {
			result = this.instances[gallery_id];
		} else {

			var instance = $.extend({}, i4_Gallery_instance	);
			instance.initialize(gallery_id);
			this.instances[gallery_id] = instance;

			result = instance;
		}

		return result;
	}
}; // i4_Gallery

var i4_Gallery_instance = {
	id: null,
	option: {},
	images: [],
	images_count: 0,

	$view_container: null,
	$gallery_container: null,

	prepared: false,

	keyup_listener: {
		next: null,
		prev: null,
		esc: null
	},

	elementClass: {
		wrapper: 'i4-gallery',
		loader: 'i4-gallery__loader',
		navigation: 'i4-gallery__navigation',
    button: 'i4-gallery__button',
    button_prev: 'i4-gallery__button-prev',
		button_back: 'i4-gallery__button-back',
    button_next: 'i4-gallery__button-next',
		slider: 'i4-gallery__slider',
		slide: 'i4-gallery__slide',
		visible: 'i4-gallery--visible'
	},

	previousScrollPos: 0,

	initialize: function(gallery_id) {
		this.images = [];
		this.option = {
			view_container: ''
		};
	}, // i4_Gallery_instance.initialize()

	set_option: function(option) {
		this.option = $.extend(this.option, option);
		return this;
	}, // i4_Gallery_instance.set_option()

	add_image: function(image) {
		this.images.push(image);

		return this.images_count++;
	}, // i4_Gallery_instance.add_image()

	show: function(slideNumber) {
		// cache current scroll position
		this.previousScrollPos = $(document).scrollTop();

		if (!this.prepared) {
		    this.prepare(slideNumber);
		}

		this.$content.hide();
		this.$gallery_container.show();

		this.$sliderContainer.slick('slickGoTo', slideNumber, true);

		$('html, body').animate({ scrollTop: this.$gallery_container.offset().top-40 }, 0);

		if (slideNumber == 0) {
    	    this.$gallery_container.find('.prev').css('visibility', 'hidden');
    	    i4_Document_listener.stop(this.keyup_listener.prev);
    	} else {
    	    this.$gallery_container.find('.prev').css('visibility', 'visible');
    	    i4_Document_listener.start(this.keyup_listener.prev);
    	}

    	if (slideNumber == this.images_count-1) {
    	    this.$gallery_container.find('.next').css('visibility', 'hidden');
    	    i4_Document_listener.stop(this.keyup_listener.next);
    	} else {
    	    this.$gallery_container.find('.next').css('visibility', 'visible');
    	    i4_Document_listener.start(this.keyup_listener.next);
    	}

		this.$gallery_container.addClass(this.elementClass.visible);

		i4_Document_listener.start(this.keyup_listener.esc);
		i4_Document_listener.run();
	}, // i4_Gallery_instance.tn_click()

	prepare: function(starting_slide) {

		if ($(this.option.view_container).length) {
			this.$view_container = $(this.option.view_container).first();
		} else {
			console.warn('i4_gallery.js: view_container not found:', this.option.view_container);
		}

		var translations = i4_Translation.get();

		this.$sliderContainer = $('<div></div>').
			addClass(this.elementClass.slider);

		this.$gallery_container = $('<div></div>').
			addClass(this.elementClass.wrapper).
			prepend(this.$sliderContainer).
			prepend(
			  "<div class='"+this.elementClass.navigation+"'>" +
          "<div class='left'>" +
            "<a class='" + this.elementClass.button + " " + this.elementClass.button_prev + " prev' href='#'>" +
              "<span>" + translations.prev + "</span>" +
            "</a>" +
          "</div>" +
          "<div class='center'>" +
            "<a class='" + this.elementClass.button + " "+this.elementClass.button_back+"' href='#'>" +
              "<span>" + translations.close + "</span>" +
            "</a>" +
          "</div>" +
          "<div class='right'>" +
            "<a class='" + this.elementClass.button + " " + this.elementClass.button_next + " next' href='#'>" +
              "<span>" + translations.next + "</span>" +
            "</a>" +
          "</div>" +
      "</div>").
			prepend("<div class='"+this.elementClass.loader+"'><div class='i4-loader'></div></div>");
		this.$content = $('<div></div>').addClass('test');
		this.$view_container.children().appendTo(this.$content);
		this.$view_container.append(this.$content);
		this.$view_container.prepend(this.$gallery_container);

		// close on click on slider bg or on close button
    this.$gallery_container.find('.'+this.elementClass.slider).on('click', this.close.bind(this));
		this.$gallery_container.find('.'+this.elementClass.button_back).on('click', this.close.bind(this));

    	$(this.images).each((function(i, item){
	    	this.$sliderContainer.append(
		    	$('<div></div>').
		    		addClass(this.elementClass.slide).
		    		append(
			    		$('<img>').
				    		attr({
					    		src: item.src,
					    		alt: item.altText
				    		})
		    		).
		    		append(item.legendText !== '' ?
			    		$('<div></div>').
							addClass('legend').
							html(item.legendText) : ''
		    		).
		    		on('click', this.close.bind(this))
	    	);

    	}).bind(this));

    	this.loadImages();

    	if (this.images_count > 0) {

    		this.$sliderContainer.slick({
			    autoplay: false,
			    speed: 1000,
			    fade: true,
			    arrows: false,
			    accessibility: false,
			    infinite: false,
			    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)'
		    });

    		this.$gallery_container.find('.next').on('click', (function(event) {
	    		event.preventDefault();
	    		this.$sliderContainer.slick('slickNext');
    		}).bind(this));

    		this.$gallery_container.find('.prev').on('click', (function(event) {
	    		event.preventDefault();
	    		this.$sliderContainer.slick('slickPrev');
    		}).bind(this));

    		this.$sliderContainer.on('beforeChange', (function(event, slick, currentSlide, nextSlide) {

				if (nextSlide == 0) {
					this.$gallery_container.find('.prev').css('visibility', 'hidden');
					i4_Document_listener.stop(this.keyup_listener.prev);
				} else {
					this.$gallery_container.find('.prev').css('visibility', 'visible');
					i4_Document_listener.start(this.keyup_listener.prev);
				}

				if (nextSlide == slick.slideCount - 1) {
					this.$gallery_container.find('.next').css('visibility', 'hidden');
					i4_Document_listener.stop(this.keyup_listener.next);
				} else {
					this.$gallery_container.find('.next').css('visibility', 'visible');
					i4_Document_listener.start(this.keyup_listener.next);
				}

				i4_Document_listener.run();

			}).bind(this));
    	}

    	this.keyup_listener.next = i4_Document_listener.add('keyup', {
    	    keys: [39],
    	    callback: (function() {
    	    	this.$sliderContainer.slick('slickNext');
    	    }).bind(this)
    	});
    	this.keyup_listener.prev = i4_Document_listener.add('keyup', {
    	    keys: [37],
    	    callback: (function() {
		    	this.$sliderContainer.slick('slickPrev');
    	    }).bind(this)
    	});
    	this.keyup_listener.esc = i4_Document_listener.add('keyup', {
    	    keys: [27],
    	    callback: (function() {
    	    	this.close();
    	    }).bind(this)
    	});

		this.prepared = true;
	}, // i4_Gallery_instance.prepare()

	close: function() {
		this.$content.show();
		this.$gallery_container.hide(400, () => {
			this.$gallery_container.removeClass(this.elementClass.visible);

			// scroll back to original position of images
			$('html, body').animate({ scrollTop: this.previousScrollPos }, 0, function () {
				this.previousScrollPos = 0;
			});
		});

		i4_Document_listener.stop(this.keyup_listener.next);
		i4_Document_listener.stop(this.keyup_listener.prev);
		i4_Document_listener.stop(this.keyup_listener.esc);
		i4_Document_listener.run();
	}, // i4_Gallery_instance.close()

	loadImages: function() {
		this.$sliderContainer.find('img').each((function(i, item){
			var $item = $(item);
    		var image = new i4_Image();
		    image.onload = (function() {
				$item.addClass('slider-loaded');
		    }).bind(this);
		    image.src = $item.attr('src');

	    }).bind(this))		;
	}

}; // i4_Gallery
